// config.js

export const version = '1.0.0';
export const navbarBreakPoint = 'xl';
export const topNavbarBreakpoint = 'lg';

export const settings = {
	isFluid: false,
	isRTL: false,
	isDark: false,
	navbarPosition: 'top',
	showBurgerMenu: false,
	currency: '$',
	isNavbarVerticalCollapsed: false,
	navbarStyle: 'transparent'
};

// ✅ SOLUCIÓN: Asignar el objeto a una variable antes de exportarlo como default
const config = { version, navbarBreakPoint, topNavbarBreakpoint, settings };
export default config;